<template>
    <div class="pos-r">
        <y-image
            v-if="avatarImg"
            :src="avatarImg.link"
            :width="imageWidth"
            :height="imageHeight"
            ratio="1"
            circle
            class="ml-3"
        />
        <y-image
            v-else
            :alt="$t('header.auth_avatar')"
            height="32px"
            width="32px"
            circle
        />

        <li
            v-if="user"
            id="r-header__auth__menu"
            :class="[{active: activeAuthMenu}]"
            class="accordion-item r-header__auth__menu"
        >
            <div
                class="head"
                @click="toggleActive"
            >
                <div
                    data-toggler
                    class="data-toggler"
                >
                    <y-icon
                        v-if="activeAuthMenu"
                        icon="chevron-up"
                        color="font"
                        size="small"
                    />
                    <y-icon
                        v-else
                        icon="chevron-down"
                        color="font"
                        size="small"
                    />
                </div>
            </div>

            <slide-up-down :active="activeAuthMenu">
                <div class="body">
                    <div class="pa-6">
                        <div>
                            <div class="r-header__auth___user d-flex align-items-start justify-content-start">
                                <span class="typo-h6 color-body-text--light-20 mb-0">
                                    {{ `${user.name_first} ${user.name_last}` }}
                                </span>
                            </div>
                            <div
                                v-if="wallets && wallets.length"
                                class="mt-2"
                            >
                                <div
                                    v-for="wallet in wallets"
                                    :key="wallet.id"
                                    class="d-flex align-items-center justify-content-between mb-6"
                                >
                                    <span class="typo-body-2">
                                        {{ wallet.title }}
                                    </span>
                                    <span class="typo-body-2 color-success-text">
                                        {{ `${separated(wallet.balance, $i18n.locale)} ${wallet.currency_title}` }}
                                    </span>
                                </div>
                                <y-chips
                                    :content="walletChargeButton.label"
                                    tag="router-link"
                                    :icon="walletChargeButton.icon.name"
                                    :library="walletChargeButton.icon.library"
                                    :prefix="walletChargeButton.icon.prefix"
                                    :to="walletChargeButton.link"
                                    :color="color"
                                    size="small"
                                    monochrome
                                />
                            </div>
                        </div>
                        <nav>
                            <ul class="r-header__auth__nav mb-0 pr-0 pt-2">
                                <span
                                    v-for="item in navigation"
                                    :key="item.id"
                                >
                                    <li
                                        v-if="item.desktop"
                                        class="r-header__auth__nav__item"
                                    >
                                        <router-link
                                            :to="{ name: item.link, query: { ...item.query } }"
                                            class="r-header__auth__nav__link d-flex align-items-center justify-content-start"
                                            :class="{ 'is-active': activeRoute(item.slug) }"
                                        >
                                            <y-icon
                                                :library="item.icon.library"
                                                :prefix="item.icon.prefix"
                                                :icon="item.icon.slug"
                                                size="small"
                                                inner
                                                class="r-header__auth__nav__icon"
                                            />
                                            {{ $t(`dashboard.nav.${item.slug}`) }}
                                        </router-link>
                                    </li>
                                    <li
                                        v-if="item.mobile"
                                        class="r-header__auth__nav__item r-header__auth__nav__item__responsive"
                                    >
                                        <router-link
                                            :to="{ name: item.link, query: { ...item.query } }"
                                            class="r-header__auth__nav__link d-flex align-items-center justify-content-start"
                                            :class="{ 'is-active': activeRoute(item.slug) }"
                                        >
                                            <y-icon
                                                :library="item.icon.library"
                                                :prefix="item.icon.prefix"
                                                :icon="item.icon.slug"
                                                size="small"
                                                inner
                                                class="r-header__auth__nav__icon"
                                            />
                                            {{ $t(`dashboard.nav.${item.slug}`) }}
                                        </router-link>
                                    </li>
                                </span>
                            </ul>
                        </nav>
                    </div>
                </div>
            </slide-up-down>
        </li>
    </div>
</template>

<script>
    import { separated } from '@nodes/helpers/number';
    import {
        YImage, YIcon, YChips,
    } from '@components/index';
    import SlideUpDown from 'vue-slide-up-down';

    export default {
        name: 'Auth',

        components: {
            YImage,
            YIcon,
            YChips,
            SlideUpDown,
        },

        props: {
            wallets           : Array,
            navigation        : Array,
            walletChargeButton: Object,
            user              : Object,
            color             : String,
            avatarImg         : Object,
            imageWidth        : String,
            imageHeight       : String,
        },

        /**
         * @inheritdoc
         */
        data() {
            return {
                activeAuthMenu: false,
            };
        },

        watch: {
            /**
             * Close auth  menu after route changed
             */
            $route() {
                this.activeAuthMenu = false;
            },
        },

        methods: {
            separated,

            /**
             * Check the Active Route
             *
             * @param {string} slug
             * @returns {boolean}
             */
            activeRoute(slug) {
                return this.$route.name.includes(slug);
            },

            /**
             * Toggle panel activeness.
             *
             * @public
             */
            toggleActive() {
                this.activeAuthMenu = !this.activeAuthMenu;
            },
        },
    };
</script>

<style lang="scss" src="./index.scss" />
